import React, { FC, useCallback } from 'react';
import FinanceProductTabs from './FinanceProductTabs';
import { useDispatch, useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import thunkActions from '../../../../../store/actions/thunkActions';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import usePriceLoadingState from '../../../../../react/usePriceLoadingState';

interface IFinanceProductTabsContainerProps {
  setIsFinCalcSpcModalOpen: (value: boolean) => void;
}

const FinanceProductTabsContainer: FC<IFinanceProductTabsContainerProps> = ({ setIsFinCalcSpcModalOpen }) => {
  const dispatch = useDispatch();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const dealError = useSelector(currentDealSelectors.getErrorStatus);
  const partExchangeId = useSelector(currentDealSelectors.getPartExchangeId);
  const isCash = useSelector(currentDealSelectors.getIsCash);
  const isDataLoading = usePriceLoadingState();

  const onFinanceProductChange = useCallback(
    (_e, value) => {
      switch (value) {
        case 'finance':
          setIsFinCalcSpcModalOpen(true);
          break;
        case 'cash':
          dispatch(thunkActions.approveCashDeal({ partExchangeId, priceDisplay }));
          break;
        default:
          break;
      }
    },
    [dispatch, partExchangeId],
  );

  return (
    <FinanceProductTabs disabled={!!dealError || isDataLoading} isCash={isCash} onChange={onFinanceProductChange} />
  );
};

export default FinanceProductTabsContainer;
